module.exports = __webpack_public_path__ + "img/horizontal_4_3_3016.351c556d.png";